module.exports = __webpack_public_path__ + "static/media/visitor5.7eb35b1b.jpg";